import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { CHAT_ROOT_ELEMENT_DOM_ID } from './constants/dom-ids';
import { store } from './index';
import { AppProviders } from './pages/app/app-providers';
import { setOptions } from './app-communication/actions/from-main-app';
import './main.css';

// React warns if createRoot() is called multiple times for the
// same DOM container. Since this micro-app can be mounted and
// re-mounted by a host app, we cache and reuse roots by DOM id.
export const roots = new Map();

function createDomElement() {
  const chatDomeElementId = CHAT_ROOT_ELEMENT_DOM_ID;

  if (document.getElementById(chatDomeElementId)) {
    return chatDomeElementId;
  }

  const chatDomElement = document.createElement('div');
  chatDomElement.id = chatDomeElementId;
  document.body.append(chatDomElement);

  return chatDomeElementId;
}

export const createChat = (domElementId = null, options = {}) => {
  const id = domElementId ? domElementId : createDomElement();
  store.dispatch(setOptions(options));

  let root = roots.get(id);

  if (!root) {
    root = createRoot(document.getElementById(id));
    roots.set(id, root);
  }

  root.render(
    <Provider store={store}>
      <AppProviders />
    </Provider>
  );
};
